import { FC } from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import { AlertBox } from '@/components/AlertBox';
import { ModalInfo, ModalInfoProps } from '@/components';
import styles from './RequestMonitoringModal.module.sass';

const PORTAL_ID = import.meta.env.VITE_REACT_APP_HUBSPOT_PORTAL_ID || '';
const FORM_ID = import.meta.env.VITE_REACT_APP_HUBSPOT_MONITORING_FORM_ID || '';

interface HubspotFormProps extends ModalInfoProps {
  formDivId?: string;
  onSuccessfulSubmit: () => void;
}

const RequestMonitoringModal: FC<HubspotFormProps> = ({
  formDivId = 'hubspot-monitoring-form-wrapper',
  isOpen,
  onClose,
  onSuccessfulSubmit,
}) => {
  const { t } = useTranslation();

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: PORTAL_ID,
    formId: FORM_ID,
    target: `#${formDivId}`,
    onFormSubmitted: () => onSuccessfulSubmit(),
  });

  return (
    <ModalInfo
      isOpen={isOpen && formCreated}
      title=""
      className={styles.modal}
      onClose={onClose}
    >
      {error && (
        <AlertBox type="danger" className={styles.alert}>
          {{
            title: parse(t('translation.ooops')),
            icon: '🤔',
          }}
        </AlertBox>
      )}
      <div id={formDivId} />
    </ModalInfo>
  );
};

export default RequestMonitoringModal;
